import { registerAppLinks } from "@shared/services/appLinkRegistry";

registerAppLinks([
  {
    uriExpression: "twin-edit.products.product.*",
    routeName: "productsDetail",
  },
]);
